import { Fragment, useCallback, useContext, useEffect, useRef, useState } from "react";
import { axiosInstance } from "../../../axios/axiosInstance";
import { GlobalContext } from "../../../Context/GlobalContext";
import { IsNumberKeyWithoutZero, isValidArray, isNumber } from "../../../Layout/Common/common";
import { ErrorItem } from "../ErrorItem";
import { useGlobalFunction } from "../../../Context/GlobalFunctionContext";
import $ from "jquery";
import { LineEntryResponse } from "./LineEntryResponse";
import { AddToCartInfoAlert } from "../../../Layout/Common/alert/addToCartInfoAlert";
export const QuickOrderLineEntry = ({ AddtoCart }) => {
  const globalcontext = useContext(GlobalContext);
  const [suggestion, setSuggestion] = useState(null);
  const [productCode, setProductCode] = useState("");
  const [errorItem, setErrorItem] = useState(null);
  const [qty, setQty] = useState(1);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [activeSuggestion, setActiveSuggestion] = useState(-1);
  const suggestionListRef = useRef(null);
  const quantityInputRef = useRef(null);
  const codeInputRef = useRef(null);
  const { refreshCartItem } = useGlobalFunction();
  const infoRef = useRef();
  const handleCallback = useCallback((errItem) => {
    try {
      if (isValidArray(errItem)) {
        setErrorItem(errItem);
        infoRef.current.showAlert(errItem[0].type, errItem[0]);
      } else {
        setErrorItem(null);
        if (codeInputRef.current) {
          codeInputRef.current.focus();
        }
        infoRef.current.showSuccess();
        refreshCartItem();
      }
      setQty(1);
      setProductCode("");
      setSuggestion(null);
    } catch (error) {
      console.error("Quick Order", error);
    }
  }, []);

  const handleOnQtyChange = (e) => {
    if (e.target.value || e.target.value == "") {
      setQty(IsNumberKeyWithoutZero(e.target.value));
    }
  };

  const handleQtyBlur = (e) => {
    if (!qty) {
      setQty(1);
    }
  };

  const handleOnType = (e) => {
    if (e.target.value || e.target.value == "") {
      setProductCode(e.target.value);
      handleOnSearch(e.target.value);
      infoRef.current?.closeAlert();
    }
  };
  const handleOnSearch = (txt) => {
    if (txt == "") setSuggestion([]);
    else {
      axiosInstance
        .post("GetStaticData/ProductCodeAutoComplete", {
          sku: txt,
        })
        .then((response) => {
          if (response.data) {
            setSuggestion(response.data);
          }
        })
        .catch((error) => console.log(error.message));
    }
  };
  const autosuggestionKeyPress = (e) => {
    if (e.key == "ArrowDown" && activeSuggestion < suggestion.length - 1) {
      setActiveSuggestion((prev) => {
        const nextIndex = prev < suggestion.length - 1 ? prev + 1 : 0;
        scrollToActiveSuggestion(nextIndex);
        return nextIndex;
      });
    } else if (e.key == "ArrowUp" && activeSuggestion > 0) {
      setActiveSuggestion((prev) => {
        const nextIndex = prev > 0 ? prev - 1 : suggestion.length - 1;
        scrollToActiveSuggestion(nextIndex);
        return nextIndex;
      });
    } else if (e.key == "Enter") {
      if (activeSuggestion >= 0 && activeSuggestion < suggestion.length) {
        setProductCode(suggestion[activeSuggestion].code);
        setShowSuggestions(false);
        if (quantityInputRef.current) {
          quantityInputRef.current.focus();
        }
      }
    }
  };
  const scrollToActiveSuggestion = (index) => {
    const list = suggestionListRef.current;
    if (list) {
      const item = list.children[index + 2] || list.children[index + 1] || list.children[index];

      if (item) {
        item.scrollIntoView({ behavior: "smooth", block: "nearest" });
      }
    }
  };
  const handleQtyKeyPress = (e) => {
    if (e.keyCode == 13) AddItemCart();
  };
  const AddItemCart = () => {
    if (productCode && qty) {
      var data = {
        sku: productCode,
        qty: parseInt(qty),
      };
      infoRef.current.closeAlert();
      AddtoCart(data, handleCallback);
    }
  };
  const handleOnPress = (e) => {
    if (e.key == "Enter") {
      quantityInputRef.current.focus();
      //AddItemCart();
    }
  };
  return (
    <Fragment>
      <div className="col-lg-12">
        <div className="quickOrder-panel">
          <div className="quickcart-search quickcart-two">
            <div className="quickOrder-container">
              <h3 className="mt-0 mb-2">Product Code</h3>
              <input
                ref={codeInputRef}
                type="text"
                onChange={handleOnType}
                value={productCode}
                autoComplete="off"
                data-required="true"
                className="form-control border border-1 py-1"
                id="quickOrderSearch"
                name="textbox"
                onFocus={() => setShowSuggestions(true)}
                onBlur={() => setTimeout(() => setShowSuggestions(false), 200)}
                onKeyDown={autosuggestionKeyPress}
                placeholder="Enter Order Code"
                onKeyPress={handleOnPress}
              />
              {showSuggestions && isValidArray(suggestion) && (
                <ul ref={suggestionListRef} className="autosuggest-suggestions">
                  {suggestion.map((item, index) => (
                    <li
                      key={index}
                      onClick={() => setProductCode(item.code)}
                      className={index == activeSuggestion ? "active" : ""}
                    >
                      {item.code}
                    </li>
                  ))}
                </ul>
              )}
            </div>
            <div className="quickOrder-qty">
              <h3 className="mt-0 mb-2">Qty</h3>
              <input
                type="text"
                min="1"
                id="txtprdqty"
                className="form-control"
                style={{ width: "100px" }}
                value={qty}
                onChange={handleOnQtyChange}
                onBlur={handleQtyBlur}
                ref={quantityInputRef}
                onKeyDown={(KeyboardEvent) => handleQtyKeyPress(KeyboardEvent)}
              />
              <div className="quickOrder-suggestions" style={{ display: "none" }}></div>
            </div>
            <div className="button-effect quickcart-effect">
              <h3 className="mt-0 mb-2 opacity-0">Add</h3>
              <div className="product-button button-effect">
                <input
                  type="button"
                  id="orderToastBtn"
                  onClick={AddItemCart}
                  disabled={!productCode}
                  className="btn btn-products btn-addcart addToCart"
                  style={{
                    padding: "11px 15px 10px 15px !important",
                    marginBottom: 0,
                  }}
                  value="Add Item"
                />
              </div>
            </div>
          </div>
          <AddToCartInfoAlert ref={infoRef} />
        </div>
      </div>
    </Fragment>
  );
};
